import styled from 'styled-components';

const ItemsGridSwiperStyles = styled.section`
  position: relative;
  .DXItemsGrid-swiper-wrap {
    position: relative;
    display: grid;
    .swiper {
      max-width: 100%;
      width: 100%;
    }
    .DXItemsGrid-arrow-prev {
      position: absolute;
      left: -30px;
      top: 0;
      bottom: 0;
      margin: auto;
      transform: translateY(-24px);
      cursor: pointer;
      @media screen and (max-width: 1099px) {
        display: none;
      }
    }
    .DXItemsGrid-arrow-next {
      position: absolute;
      right: -30px;
      top: 0;
      bottom: 0;
      margin: auto;
      transform: translateY(-24px);
      cursor: pointer;
      @media screen and (max-width: 1099px) {
        display: none;
      }
    }
    .swiper-button-disabled {
      visibility: hidden;
    }
  }
`;

export default ItemsGridSwiperStyles;
